<template>
  <v-dialog v-model="dialog" scrollable max-width="700px">
    <v-card>
      <v-card-title class="headline">
        <span class="text-capitalize" v-html="title"></span>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-3">
        <v-card outlined tile>
          <v-card-title class="pa-0">
            <base-table-header @search="onSearch" @reload="onReload">
              <template v-slot:subtitle> Daftar <span class="blue--text" v-text="total" /> </template>
            </base-table-header>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <base-list-table
              :hideHeader="true"
              :loading="loading"
              :item="data"
              :total="total"
              :usePaging="false"
              @fetch="fetchData"
            >
              <template slot-scope="{ item }">
                <slot :row="item" />
              </template>
            </base-list-table>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <base-table-footer
              :use-number="!simplePaging"
              :pageTotal="pageTotal"
              :total="total"
              @changePage="onChangePage"
            ></base-table-footer>
          </v-card-actions>
        </v-card>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.native="dialog = false">
          Batal
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import mixin from '@mixins/list';

export default {
  name: 'popupSelector',
  mixins: [mixin],
  props: {
    title: {
      type: String,
      default: 'Pilih Selector',
    },
    simplePaging: {
      type: Boolean,
      default: false,
    },
    fetch: {
      type: Function,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.fetchData();
    },

    close() {
      this.dialog = false;
    },
  },
};
</script>
